import React from 'react';
import classNames from 'classnames';
import { Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { renderApplicantOptionMin } from '../../../utils/formatters';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import CustomSelectInputWithHelper from '../../../components/fields/SelectInput/CustomSelectInputWithHelper';
import { loadRepresentativeList } from '../actions';
import { setRepresentative } from '../../../utils/utils';
import renderMessage from '../../../components/fields/renderMessage';
import RepresentativeDTO from '../../../dto/RepresentativeDTO';

export default function AutoAcceptRepresentative(props) {
  const {
    control, prefix = '', setValue = () => {},
  } = props;
  const dto = new RepresentativeDTO();
  const attributes = dto.getAttributesByName();

  const optionFormatter = item => ({
    value: item.id, name: item.full_name, applicant: item, legal_entity_type: item?.legal_entity_type,
  });

  const onSelectApplicant = item => {
    const { applicant } = item;
    if (applicant === undefined) {
      return;
    }

    setRepresentative(applicant, setValue);
  };

  const customToggleContent = (props, value, options, anchorElement) => {
    const {
      label,
      isRequired,
      fieldState = {
        error: '',
      },
    } = props;
    const { error } = fieldState;
    const isError = Boolean(error);
    const item = options.find(option => option.value === value);
    return (
      <div className="form-control-wrapper material auto-accept-applicant-input" ref={anchorElement}>
        <div className={classNames('input-block', { 'is-invalid': isError })} title={renderMessage(label)}>
          {renderApplicantOptionMin(item)}
          <div htmlFor={props.id} className="form-input-label">
            {isRequired ? <span className="form-label-mark-required">*</span> : null}
            {renderMessage(label)}
          </div>
          <span className="input-after-block">
            <div className="select-arrow-wrapper">
              <Icons customIcon className="select-arrow" width={12} height={8} icon="arrow-down" />
            </div>
          </span>
        </div>
        {isError ? <div className="invalid-feedback">{renderMessage(error)}</div> : null}
      </div>

    );
  };
  return (
    <FieldDTO
      control={control}
      dtoObject={attributes.representative_id}
      usePortal
      withLabel
      variant="material"
      component={CustomSelectInputWithHelper}
      portalClassName="executor-selector"
      className="mt-3"
      loadAction={loadRepresentativeList}
      customRenderOptions={renderApplicantOptionMin}
      optionFormatter={optionFormatter}
      customToggleContent={customToggleContent}
      filterName="search"
      onSelect={onSelectApplicant}
    />
  );
}
